import React, { Component } from 'react';
import Navitem from './Navitem';
import { saveAs } from 'file-saver';
import { slide as Menu } from 'react-burger-menu'
import { useMediaQuery } from 'react-responsive'

var styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '3vw',
    height: '3vw',
    right: '3.65vw',
    top: '4.8vw'
  },
  bmBurgerBars: {
    background: 'var(--text-color)'
  },
  bmBurgerBarsHover: {
    background: 'var(--text-color)'
  },
  bmCrossButton: {
    width: '3vw',
    height: '3vw',
  },
  bmCross: {
    background: 'var(--text-color)'
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
    top:'0px'
  },
  bmMenu: {
    fontSize: 'var(--fontsize-nav)',
    width: '40vw',
    background: 'var(--theme-color)',
    float:'right',
    'padding-top':'10vw',
    'border-left':'1px solid var(--text-color)'
  },
  bmMorphShape: {
  },
  bmItemList: {
    color: 'var(--text-highlight)',
    display:'block'
  },
  bmItem: {
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1000,
    transform: 'none',
    overflow: 'hidden',
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.3s, visibility 0.3s'
  }
}


class Navbar extends Component {
    constructor(props)
    {
        super(props);
        this.state={
            'NavItemActive':'',
            'isTablet': false,
            'isPhone' : false,
            'isOpen': false,
        }
    }
    activeitem=(x)=>
    {
        this.setState({'isOpen':false})
    };
    closeMenu=()=>
    {
      this.setState({'isOpen':false})
    }
    handleStateChange=(x)=>
    {
      this.setState({'isOpen':x.isOpen})
    }
    updateDimensions=()=>
    {
      var w = window,
         d = document,
         documentElement = d.documentElement,
         body = d.getElementsByTagName('body')[0],
         width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
         height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
      this.setState({'isTablet':width < 1380})
      this.setState({'isPhone':width < 1023})
    }
    componentWillMount() {
          this.updateDimensions();
    }
     componentDidMount() {
       window.addEventListener('resize', this.updateDimensions);
       this.setState({'isOpen':false})
     }
     componentWillUnmount() {
       window.removeEventListener('resize', this.updateDimensions);
     }

    render() {
        return (
          <div class="navmargin">
            {this.state.isPhone &&
              <nav class="mynav">
                <Navitem className="navhome" item="Haozhe Zhou 周浩哲" tolink = "/" activec={this.activeitem}></Navitem>
                <Menu right styles={styles} isOpen={this.state.isOpen}  onStateChange={this.handleStateChange}>
                  <ul>
                    <Navitem className="navitem" item="Publication" tolink="#publications"  activec={this.activeitem}></Navitem>
                    <Navitem className="navitem" item="Vitae" tolink="/HaozheCV.pdf"  activec={this.activeitem}></Navitem>
                    <Navitem className="navitem" item="Contacts" tolink="#contacts"  activec={this.activeitem}></Navitem>
                  </ul>
                </Menu>
              </nav>
            }
            {!this.state.isPhone && this.state.isTablet &&
              <nav class="mynav">
                <ul>
                  <Navitem className="navhome" item="Haozhe Zhou 周浩哲" tolink = "/" activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Contacts" tolink="#contacts"  activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Vitae" tolink="/HaozheCV.pdf"  activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Publication" tolink="#publications"  activec={this.activeitem}></Navitem>
                </ul>
              </nav>
            }
            {!this.state.isPhone && !this.state.isTablet &&
              <nav class="mynav">
                <ul>
                  <Navitem className="navhome" item="Haozhe Zhou 周浩哲" tolink = "/" activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Contacts" tolink="#contacts"  activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Vitae" tolink="/HaozheCV.pdf"  activec={this.activeitem}></Navitem>
                  <Navitem className="navitem" item="Publication" tolink="#publications"  activec={this.activeitem}></Navitem>
                </ul>
              </nav>
            }
          </div>
            )
        }
    }

    export default Navbar
